import { TitleCasePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@ids-components';
import { CardComponent } from '@microsec/components';
import { DOMAIN, SCOPE } from '@microsec/constants';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';

@Component({
  selector: 'app-shared-user-access',
  templateUrl: './shared-user-access.component.html',
  styleUrls: ['./shared-user-access.component.scss'],
  imports: [DividerModule, ButtonModule, CardComponent, TitleCasePipe],
  providers: [TitleCasePipe],
})
export class SharedUserAccessComponent extends BaseComponent implements OnInit {
  async ngOnInit() {
    await this.prepareConfigs();
  }

  openLink() {
    window.open(`https://${localStorage.getItem(DOMAIN)}/auth/admin/microsec/console/#/microsec/users`, '_blank');
  }

  get scope() {
    return !this.breadcrumbConfig?.projectId ? SCOPE.ORGANIZATION : SCOPE.PROJECT;
  }
}
